import { UUID } from '../basic/basic';
import { CamelCaseKeys } from '../camel-case';
import { State } from '../state/state';

export enum SeeClientsEnum {
  videoAndInPerson = 'mix_of_video_and_in_person',
  telehealth = 'exclusively_telehealth',
  inPerson = 'exclusively_in_person',
}

export type PracticeLocationOriginal = {
  id?: UUID;
  user_practice_id?: UUID;
  hide_street_address?: boolean;
  address_line1?: string;
  address_line2?: string;
  city?: string;
  state?: State;
  zip?: string;
  phone?: string;
  phone_ext?: string;
  see_clients_location?: boolean;
  location_state?: State;
};

export type PracticeLocation = CamelCaseKeys<PracticeLocationOriginal>;

export type VisitReason = {
  label: string;
  value: string;
};
